//@author: devin
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    NgZone,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import { S25DropdownAbstract } from "../s25.dropdown.abstract";
import {
    DataIngestionService,
    INGESTION_POINT_TYPE_ID,
    IngestionPoint,
} from "../../data-ingestion/data.ingestion.service";
import { S25Util } from "../../../util/s25-util";
import { TypeManagerDecorator } from "../../../main/type.map.service";

@TypeManagerDecorator("s25-ingestion-point-dropdown")
@Component({
    selector: "s25-ingestion-point-dropdown",
    template: `
        @if (this.items) {
            <s25-generic-dropdown
                [(chosen)]="this.chosen"
                [hasFav]="this.hasFav"
                [onSelect]="this.onSelect"
                [items]="this.items"
                [staticItems]="this.staticItems"
                [autoOpen]="this.autoOpen"
                [alwaysOpen]="this.alwaysOpen"
                [hideSearch]="this.hideSearch"
                [focusFirst]="false"
                [searchEnabled]="true"
                [apiBean]="this.apiBean"
                [placeholder]="'Select a Form'"
                [resetSelectedOnCleanup]="this.resetSelectedOnCleanup"
                (chosenChange)="onChosenChange($event)"
            >
            </s25-generic-dropdown>
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false,
})
export class S25IngestionPointDropdownComponent extends S25DropdownAbstract implements OnInit {
    @Input() category?: string; // Filter by ingestion point category
    @Input() subCat?: string; // Filter by ingestion point sub category
    @Input() enabledOnly?: boolean = true; // Only show enabled forms by default

    constructor(
        private zone: NgZone,
        private elementRef: ElementRef,
        private cd: ChangeDetectorRef,
    ) {
        super();
    }

    ngOnInit() {
        this.refresh();
    }

    refresh(inputs?: any) {
        if (inputs) {
            S25Util.extend(this, inputs);
        }

        DataIngestionService.getIngestionPoints()
            .then((data: IngestionPoint[]) => {
                this.zone.run(() => {
                    let forms = data || [];
                    forms.sort(S25Util.shallowSort("ingestionPointName"));

                    // Apply filters
                    if (this.enabledOnly) {
                        forms = forms.filter((form) => form.enabled !== false);
                    }

                    if (this.category) {
                        forms = forms.filter((form) => form.category === this.category);
                    }

                    if (this.subCat) {
                        forms = forms.filter((form) => form.subCat === this.subCat);
                    }

                    // Convert to dropdown items
                    this.items = forms.map((form) => {
                        return {
                            txt: form.ingestionPointName || `Form ${form.ingestionPointId}`,
                            val: form.ingestionPointId,
                            itemTypeId: INGESTION_POINT_TYPE_ID,
                            itemId: form.ingestionPointId,
                            itemName: form.ingestionPointName,
                            data: form,
                        };
                    });

                    this.onLoad && this.onLoad();

                    try {
                        this.cd.detectChanges();
                    } catch (error: any) {}
                });
            })
            .catch((error) => {
                console.error("Error loading forms:", error);
                S25Util.showError("Error loading forms: " + error);
            });
    }
}
